<template>
  <div class="notification" v-on-clickaway="away">
    <div
      class="notification__header"
      :class="{ 'notification__header--active': click }"
      @click="toggleDropdown"
    >
      <slot name="fa-icon"></slot>
    </div>

    <div
      class="notification__content"
      :style="{ '--max-height-notification-content': maxContentHeight }"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";

export default {
  mixins: [clickaway],
  props: {
    maxContentHeight: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      click: false
    };
  },
  methods: {
    toggleDropdown() {
      this.click = !this.click;
    },
    away() {
      if (this.click) {
        this.click = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/DropdownNotification.vue